/**
 * @readonly
 * @enum {number}
 */
export const TpmsIssueSeverity = Object.freeze({
    NONE: 0,
    WARNING: 1,
    CRITICAL: 2,
    CATASTROPHIC: 3
})
